<template>
  <div>
    <div class="md-layout-item md-gutter trade-type-content placement-adjustments md-alignment-center-space">
      <div class="md-layout-item md-size-15 align-columns">
        <h6 class="title-selection">Price</h6>
      </div>
      <div class="md-layout-item md-gutter checkbox-order small-screen-display-order">
        <div
          class="md-layout-item fix md-gutter md-size-25"
        >
          <md-radio
            v-model="freeSelected"
            class="md-primary"
            value="free"
            data-cy="newItemPaymentType-Free"
            @change="checkEventValue"
            :class="{ 'is-selected': freeSelected === 'free' }"
            >Free</md-radio
          >
        </div>
        <div class="md-layout-item md-gutter small-screen-column">
          <div
            class="md-layout-item md-gutter md-size-40 space-itens"
          >
            <md-checkbox
              v-model="pointsSelected"
              value="points"
              class="md-primary"
              @change="checkEventValue"
              data-cy="newItemPaymentType-Points"
              :class="{ 'is-selected': pointsSelected === 'points' }"
              >Points</md-checkbox
            >
            <div>
              <SInputCurrency
                class="currency-styled-component"
                v-model="payload.points"
                data-cy="newItemValuePoints"
                @atBlur="storePaymentValues"
                currency="null"
                :allowNegative="false"
                :valueAsInteger="true"
                precisionValue="0"
                :paymentType="`points`"
                ref="currencyPoints"
              />
            </div>
          </div>
          <div
            class="md-layout-item md-gutter md-size-40 space-itens"
          >
            <md-checkbox
              v-model="cashSelected"
              class="md-primary"
              data-cy="newItemPaymentType-Cash"
              value="money"
              @change="checkEventValue"
              :class="{ 'is-selected': cashSelected === 'money' }"
              >Cash</md-checkbox
            >
            <div>
              <SInputCurrency
                class="currency-styled-component"
                v-model="payload.cash"
                data-cy="newItemValueCash"
                @atBlur="storePaymentValues"
                locale="en"
                currency="USD"
                :allowNegative="false"
                precisionValue="2"
                ref="currencyCash"
                :paymentType="`cash`"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row px-2 mb-3 small-screen-text" :class="{ 'mb-4': hasAlert }">
      <div v-if="acceptPoints && acceptCash" class="col paymentText">
        {{ paymentText }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import ItemHelperVue from "../../mixins/ItemHelper.vue";
import SInputCurrency from "@/components/atoms/SInputCurrency";
import { parse } from "vue-currency-input";
import itemType from "@/enum/item-type";
export default {
  name: "ReviewItemPrice",
  mixins: [ItemHelperVue],
  props: ["hasAlert"],
  components: {
    SInputCurrency,
  },
  data() {
    return {
      pointsSelected: null,
      cashSelected: null,
      freeSelected: null,
      payload: {
        points: 0,
        cash: 0,
      },
      pointsOptions: {
        currency: null,
        allowNegative: false,
        valueAsInteger: true,
        precision: 0,
      },
      cashOptions: {
        locale: "en",
        currency: "USD",
        autoDecimalMode: true,
        allowNegative: false,
        precision: 2,
      },
      option: [],
    };
  },
  methods: {
    ...mapActions(["setNewItemPaymentType", "setNewItemPaymentValues"]),
    checkEventValue(e) {
      this.$emit("change");
      if (e === "free") {
        this.pointsSelected = null;
        this.cashSelected = null;
        this.option = "free";
      } else if (
        (e === "money" || e === "points") &&
        this.freeSelected === "free"
      ) {
        this.freeSelected = null;
        this.option = null;
        if (e === "money") {
          this.cashSelected = "money";
          this.option = ["money"];
        } else {
          this.pointsSelected = "points";
          this.option = ["points"];
        }
      }

      this.storePaymentType();
    },
    storePaymentType() {
      if (this.pointsSelected === "points") {
        if (!this.option.includes("points")) {
          this.option.push("points");
        }
      } else {
        if (this.option.includes("points")) {
          this.option.splice(this.option.indexOf("points"), 1);
        }
      }
      if (this.freeSelected === "free") {
        if (!this.option.includes("free")) {
          this.option.push("free");
        }
      } else {
        if (this.option.includes("free")) {
          this.option.splice(this.option.indexOf("free"), 1);
        }
      }

      if (this.cashSelected === "money") {
        if (!this.option.includes("money")) {
          this.option.push("money");
        }
      } else {
        if (this.option.includes("money")) {
          this.option.splice(this.option.indexOf("money"), 1);
        }
      }

      if (this.itemPaymentType !== this.option) {
        this.setNewItemPaymentType(this.option);
      }
      this.storePaymentValues();
    },
    validatePayloadType() {
      if (typeof this.payload.points === "string") {
        this.payload.points = parse(this.payload.points, this.pointsOptions);
      }
      if (typeof this.payload.cash === "string") {
        if (!this.payload.cash.includes(".")) this.payload.cash += ".00";
        this.payload.cash = parse(this.payload.cash, this.cashOptions);
      }
    },
    storePaymentValues() {
      this.validatePayloadType();
      if (!this.acceptPoints) this.payload.points = 0;
      if (!this.acceptCash) this.payload.cash = 0;
      if (this.acceptPoints && this.itemPaymentPoints !== this.payload.points) {
        if (!this.payload.points) {
          this.removePaymentType("Points");
        }
        this.setNewItemPaymentValues({ input: this.payload });
        this.storeItemSession();
      }
      if (this.acceptCash && this.itemPaymentCash !== this.payload.cash) {
        if (!this.payload.cash) {
          this.removePaymentType("Cash");
        }
        this.setNewItemPaymentValues({ input: this.payload });
        this.storeItemSession();
      }
      if (
        !this.acceptPoints &&
        this.payload.points === 0 &&
        !this.acceptCash &&
        this.payload.cash === 0
      ) {
        this.setNewItemPaymentValues({ input: this.payload });
        this.storeItemSession();
      }
      this.storeItemSession();
    },
    removePaymentType(type) {
      const index = this.option.findIndex((payType) => payType.option === type);
      this.$refs.buttons.selectButton(index);
    },
    getPaymentPoints() {
      return this.itemPaymentPoints;
    },
    getPaymentCash() {
      return this.itemPaymentCash;
    },
    focusCash() {
      this.$refs.currencyCash.focus();
    },
    focusPoints() {
      this.$refs.currencyPoints.focus();
    },
  },
  computed: {
    acceptPoints() {
      return this.option && this.option.includes("points")
    },
    acceptCash() {
      return this.option && this.option.includes("money")
    },
    saved() {
      if (this.option) {
        return this.option;
      }
      return null;
    },
    paymentText() {
      if (
        this.newItem.type === itemType.GIVE ||
        this.newItem.type === itemType.LEND
      ) {
        return `Choosing points and cash as accepted payment methods, only one will be used for the transaction
           of the item: or points or cash, to be chosen by the requester when expressing interest in the item.`;
      } else if (
        this.newItem.type === itemType.RECEIVE ||
        this.newItem.type === itemType.BORROW
      ) {
        return `Choosing points and cash as payment methods, only one will be used for the transaction of the
           item: or points or cash, to be chosen by the offerer when expressing interest in the trade.`;
      }
      return null;
    },
  },
  watch: {
    itemPaymentPoints() {
      this.payload.points = this.itemPaymentPoints.toLocaleString("en-US", {
        currency: "USD",
      });
    },
    itemPaymentCash() {
      this.payload.cash = this.itemPaymentCash.toLocaleString("en-US", {
        currency: "USD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      if (!this.payload.cash.includes(".")) this.payload.cash += ".00";
    },
  },
  mounted() {
    setTimeout(() => {
      if (this.itemPaymentType) {
        this.option = JSON.parse(JSON.stringify(this.itemPaymentType));

        if (this.option === "free") {
          this.freeSelected = "free";
        }

        if (this.itemPaymentPoints) {
          this.payload.points = this.itemPaymentPoints.toLocaleString("en-US", {
            currency: "USD",
          });
          this.pointsSelected = "points";
        }
        if (this.itemPaymentCash) {
          this.payload.cash = this.itemPaymentCash.toLocaleString("en-US", {
            currency: "USD",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
          this.cashSelected = "money";
        }
      }
    }, 3000);
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1024px) {
  .trade-type-content {
    flex-wrap: nowrap;
    align-items: center;
  }
}
.title-selection {
  font-style: normal;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: 1.25px;
  color: rgba(0, 0, 0, 0.9);
  font-size: 16px;
}
.checkbox-order {
  flex-direction: row-reverse;
}
.md-layout-item {
  display: flex;
  align-items: center;
}
.align-columns {
  margin-right: 8px;
}
.space-itens {
  margin-right: 35px;
  margin-left: 24px;
}
.placement-adjustments {
  height: 76px;
}
.fix {
  margin-left: 24px;
  margin-right: -28px;
}

@media screen and (min-width: 1281px) and (max-width: 1399px) {
  .space-itens {
    margin-left: 8px;
  }
}
@media screen and (min-width: 1199px) and (max-width: 1280px) {
  .space-itens {
    margin-left: 20px;
  }
}
@media screen and (min-width: 1024px) and (max-width: 1199px) {
  .space-itens {
    margin-left: 15px;
    margin-right: 15px;
  }
  .fix {
    margin-left: 15px;
  }
}
@media screen and (max-width: 1023px) {
  .small-screen-display-order {
    display: flex;
    flex-direction: row;
  }
  .fix {
    margin-left: 42px;
  }
  .small-screen-column {
    display: flex;
    flex-direction: column;
  }
  .small-screen-text {
    margin-top: 24px;
  }
}
@media screen and (min-width: 1025px) and (max-width: 1199px) {
  .trade-type-content {
    margin-left: 56px;
  }
}
@media screen and (max-width: 1024px) {
  .trade-type-content {
    margin-left: 12px;
  }
}
</style>

<style lang="scss">
.currency-styled-component input {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  border: 1px solid #939393;
  box-sizing: border-box;
  border-radius: 4px;
  height: 1rem;
  margin-top: 1em;
  min-width: 5rem;
  padding-left: 0.5rem;
  margin-left: 5px;
}
.currency-styled-component input:focus {
  border: 1px solid $primary !important;
}
.md-checkbox.md-theme-swampum-primary.md-checked .md-checkbox-container {
  background-color: $primary !important;
  border-color: $primary !important;
}
.md-checkbox .md-checkbox-container {
  border-color: $primary !important;
}
</style>
